import { render, staticRenderFns } from "./ProductPower.vue?vue&type=template&id=01e33157&scoped=true&"
import script from "./ProductPower.vue?vue&type=script&lang=js&"
export * from "./ProductPower.vue?vue&type=script&lang=js&"
import style0 from "./ProductPower.vue?vue&type=style&index=0&id=01e33157&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e33157",
  null
  
)

export default component.exports